import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

const formatFilterDate = (value) => {
    if (!value) return ''
    const parsed = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD'], true)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : value
}

export const farmDailyLogList = createAsyncThunk('farmDailyLogList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'farm_daily_log_list',
            params: {
                pageNo: data?.currentPage,
                pageSize: data?.pageSize,
                ...(data?.search ? { search: data.search } : {}),
                ...(data?.farmId ? { farm_id: data.farmId } : {}),
                ...(data?.cropId ? { crop_id: data.cropId } : {}),
                ...(data?.roomId ? { room_id: data.roomId } : {}),
                ...(data?.fromDate ? { from_date: formatFilterDate(data.fromDate) } : {}),
                ...(data?.toDate ? { to_date: formatFilterDate(data.toDate) } : {}),
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token"),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const farmDailyLogListSlice = createSlice({
    name: 'farmDailyLogList',
    initialState: {
        data: [],
        totalCount: 0,
    },
    extraReducers: (builder) => {
        builder.addCase(farmDailyLogList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const body = action.payload.data
                state.data = Array.isArray(body?.data) ? body.data : []
                state.totalCount = body?.total_count ?? state.data.length
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
                state.data = []
                state.totalCount = 0
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.data = []
                state.totalCount = 0
            } else {
                state.data = []
                state.totalCount = 0
            }
        });
        builder.addCase(farmDailyLogList.rejected, (state) => {
            state.data = []
            state.totalCount = 0
        })
    }
})

export default farmDailyLogListSlice.reducer;
